module.exports = __webpack_public_path__ + "front/img/edm-banner-xianxia-qd.ec280a8b.png";